export * from './lib/design-system-docs-content.module';
